import FormField, {
  FormFieldSelectProps,
} from 'components/form-field/form-field';
import { useSelectCompanyFieldQuery } from 'generated/graphql';
import React, { Fragment, FunctionComponent, useEffect, useMemo } from 'react';
import { DropdownItemProps } from 'semantic-ui-react';

type SelectCompanyFieldProps = Omit<
  FormFieldSelectProps,
  'options' | 'type' | 'loading' | 'disabled'
> & { shouldRefetch: boolean; onRefetch: () => void };

const SelectCompanyField: FunctionComponent<SelectCompanyFieldProps> = ({
  multiple,
  shouldRefetch,
  onRefetch,
  ...rest
}) => {
  const { data, loading, error, refetch } = useSelectCompanyFieldQuery({
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (shouldRefetch) {
      refetch();
      onRefetch();
    }
  }, [shouldRefetch]);

  const options: DropdownItemProps[] = useMemo(() => {
    if (data?.company) {
      return data.company.map((company) => ({
        key: company.id,
        value: company.id,
        text: company.name,
      }));
    }
    return [];
  }, [data?.company]);

  const placeholder = useMemo(() => {
    if (loading) {
      return 'Chargement des entreprises...';
    }
    if (multiple) {
      return 'Selectionnez des entreprises...';
    }
    return 'Selectionnez une entreprise...';
  }, [loading, multiple]);

  if (error) return <Fragment>Error! {error.message}</Fragment>;

  return (
    <FormField
      type="select"
      loading={loading}
      disabled={loading}
      options={options}
      multiple={multiple}
      placeholder={placeholder}
      {...rest}
    />
  );
};

export default SelectCompanyField;
